import styled from 'styled-components';

import HeadlineTextBlock from '@tmh-website/components/shared/HeadlineTextBlock';
import type { PrefixProperties } from '@tmh-website/shared/types';
import { assertUnreachable } from '@tmh-website/shared/helpers';
import StyledGlobal, { SectionBase } from '@tmh-website/styles/global';

import { formThemes } from './Form.theme';
import type { FormComponent, FormThemeColor } from './Form.types';

export const Section = styled(SectionBase)<{ $themeColor: FormThemeColor }>`
  color: ${props => props.theme.color[formThemes[props.$themeColor].text]};
  background-color: ${props => props.theme.color[formThemes[props.$themeColor].background]};
`;

export const AdjustHeadlineTextBlock = styled(HeadlineTextBlock)`
  margin-bottom: ${props => props.theme.gap.medium};
  @media (${props => props.theme.breakpoint.md.up}) {
    margin-bottom: ${props => props.theme.gap.large};
  }
`;

export type FormWrapperProps = PrefixProperties<Pick<FormComponent, 'alignment'>, '$'>;

export const FormWrapper = styled.div<FormWrapperProps>`
  display: flex;
  justify-content: ${({ $alignment }) => {
    switch ($alignment) {
      case 'left':
        return 'flex-start';
      case 'center':
        return 'center';
      case 'right':
        return 'flex-end';
      default:
        assertUnreachable($alignment);
    }
  }};

  > ${StyledGlobal.WrapperSmall} {
    flex: 1;
    padding: 0;
    margin: 0;
  }
`;
